import { render, staticRenderFns } from "./GuiaCliente.vue?vue&type=template&id=22dd8b59&scoped=true&"
import script from "./GuiaCliente.vue?vue&type=script&lang=js&"
export * from "./GuiaCliente.vue?vue&type=script&lang=js&"
import style0 from "./GuiaCliente.vue?vue&type=style&index=0&id=22dd8b59&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd8b59",
  null
  
)

export default component.exports